module.exports = __webpack_public_path__ + "img/empty.fab473fc.png";